<div class="mona-maintenance">
    <div class="mona-maintenance__trigger">
        <span>
            {{ 'lockScreen.maintenance.title' | translate }}
        </span>
        <mat-icon [inline]="true" class="mona-maintenance__icon">warning</mat-icon>
    </div>
</div>
